export const A2UI_PREVIEW_IMPORT_KEY_COOKIE = 'a2ui_preview_import_key';
export const A2UI_PREVIEW_TRANSFER_CHUNK_COUNT_COOKIE = 'a2ui_preview_payload_chunks';
export const A2UI_PREVIEW_TRANSFER_CHUNK_COOKIE_PREFIX = 'a2ui_preview_payload_';
export const A2UI_PREVIEW_TRANSFER_MAX_CHUNKS = 4;
export const A2UI_PREVIEW_TRANSFER_REQUEST_HEADER = 'x-a2ui-preview-transfer';

export function getA2UIPreviewTransferChunkCookieName(index: number) {
  return `${A2UI_PREVIEW_TRANSFER_CHUNK_COOKIE_PREFIX}${index}`;
}

export function getA2UIPreviewTransferChunkCookieNames(chunkCount: number) {
  return Array.from({ length: chunkCount }, (_, index) => getA2UIPreviewTransferChunkCookieName(index));
}

export const A2UI_PREVIEW_SAMPLE_INPUT = `{
  "canvas_surface": {
    "surface_id": "surface-preview-demo",
    "surface_version": 1,
    "payload": {
      "objects": [
        {
          "beginRendering": { "surfaceId": "surface-preview-demo", "root": "root" }
        },
        {
          "surfaceUpdate": {
            "surfaceId": "surface-preview-demo",
            "components": [
              { "id": "root", "component": { "Card": { "child": "panel" } } },
              { "id": "panel", "component": { "Column": { "alignment": "stretch", "children": { "explicitList": ["header", "teaser", "tags", "divider", "actions"] } } } },
              { "id": "header", "component": { "Row": { "alignment": "center", "children": { "explicitList": ["title-block", "rating"] } } } },
              { "id": "title-block", "component": { "Column": { "alignment": "start", "children": { "explicitList": ["title", "subtitle"] } } } },
              { "id": "title", "component": { "Label": { "text": { "path": "title" }, "variant": "title" } } },
              { "id": "subtitle", "component": { "Label": { "text": { "literalString": "Official canonical binding objects." }, "variant": "caption", "color": "secondary" } } },
              { "id": "rating", "component": { "Rating": { "rating": { "literalNumber": 5 }, "text": { "literalString": "v0.8" } } } },
              { "id": "teaser", "component": { "MarkdownView": { "text": { "path": "subtitle" } } } },
              { "id": "tags", "component": { "FilterTags": { "tags": { "literalArray": ["explicitList", "literalString", "literalNumber", "literalBool"] } } } },
              { "id": "divider", "component": { "Divider": {} } },
              { "id": "actions", "component": { "Row": { "alignment": "center", "children": { "explicitList": ["run", "copy"] } } } },
              { "id": "run", "component": { "Button": { "child": "run-label", "enabled": { "literalBool": true }, "action": { "name": "submit" } } } },
              { "id": "run-label", "component": { "Label": { "text": { "literalString": "Run preview" }, "variant": "bodySansSemibold" } } },
              { "id": "copy", "component": { "Button": { "child": "copy-label", "enabled": { "literalBool": true }, "action": { "name": "copy_payload" } } } },
              { "id": "copy-label", "component": { "Label": { "text": { "literalString": "Copy payload" }, "variant": "bodySansSemibold" } } }
            ]
          }
        },
        {
          "dataModelUpdate": {
            "surfaceId": "surface-preview-demo",
            "contents": [
              { "key": "title", "valueString": "A2UI v0.8 preview" },
              { "key": "subtitle", "valueString": "Debug inputs use canonical bindings only." }
            ]
          }
        }
      ]
    }
  }
}`;
